/**
 * Extracted from sections/bento-grid.liquid (inline <script> at line 170).
 * Config bridge: window.__nsBentoGridSections, keyed by section id. The inline block
 * only needed Liquid for the section id, so the id is handed over as data
 * and the logic now runs from a cacheable, deferred asset instead of being
 * parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances each initialise.
 */

(function () {
  var cfg = window.__nsBentoGridSections = window.__nsBentoGridSections || {};
  function boot(nsSectionId, nsSettings) {
      (function () {
        var SECTION_ID = nsSectionId;

        function init() {
          var root = document.getElementById('shopify-section-' + SECTION_ID);
          if (!root) return;

          var grid = root.querySelector('[data-nsbg-grid]');
          if (!grid) return;

          root.querySelectorAll('.nsbg__toggle').forEach(function (btn) {
            if (btn.dataset.nsbgBound) return;
            btn.dataset.nsbgBound = '1';

            btn.addEventListener('click', function () {
              var item = btn.closest('.nsbg__item');
              var body = item && item.querySelector('.nsbg__body');
              if (!item || !body) return;

              var open = item.hasAttribute('data-nsbg-open');
              if (open) {
                item.removeAttribute('data-nsbg-open');
                body.hidden = true;
              } else {
                item.setAttribute('data-nsbg-open', '');
                body.hidden = false;
              }
              btn.setAttribute('aria-expanded', open ? 'false' : 'true');
            });
          });

          var thumb = root.querySelector('.nsbg__thumb');
          if (!thumb) return;

          function sync() {
            var total = grid.scrollWidth;
            if (!total) return;
            var visible = Math.min(grid.clientWidth / total, 1);
            thumb.style.setProperty('--nsbg-thumb-w', (visible * 100).toFixed(2) + '%');
            thumb.style.setProperty('--nsbg-thumb-x', ((grid.scrollLeft / total) * 100).toFixed(2) + '%');
          }

          if (!grid.dataset.nsbgBound) {
            grid.dataset.nsbgBound = '1';
            grid.addEventListener('scroll', function () {
              window.requestAnimationFrame(sync);
            }, { passive: true });
            window.addEventListener('resize', sync);
          }
          sync();
        }

        init();

        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:section:load', function (event) {
            if (!event.detail || event.detail.sectionId === SECTION_ID) init();
          });
        }
      })();
  
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
